import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, FlaskConical, Layers, Target } from "lucide-react";

import { Container } from "@/platform/layout/container";
import { Badge } from "@/platform/ui/badge";
import { Button } from "@/platform/ui/button";
import { Blob, SoftStar } from "@/platform/ui/illustrations/blobs";

const MODES = [
  {
    to: "/usp/1afase",
    icon: Target,
    title: "1ª fase",
    desc: "90 questões objetivas em 5h. Distribuição calibrada conforme a banca. Nota e desempenho por disciplina.",
    status: "ativo",
  },
  {
    to: "/usp/2afase",
    icon: FlaskConical,
    title: "2ª fase",
    desc: "Discursivas por disciplina, correção item a item com abordagem esperada Fuvest.",
    status: "ativo",
  },
  {
    to: "#",
    icon: Layers,
    title: "Prova completa",
    desc: "1ª + 2ª fase combinadas com nota projetada ponderada pelo curso. Disponível no beta.",
    status: "em breve",
  },
];

export function UspSimuladorHubPage() {
  return (
    <div className="relative overflow-hidden bg-mesh min-h-[calc(100vh-56px)]">
      <Blob color="sky" className="pointer-events-none absolute -left-32 -top-20 w-96 opacity-20 blur-2xl animate-blob" />
      <SoftStar color="mint" className="pointer-events-none absolute right-12 top-32 w-12 opacity-50 animate-float" />

      <Container size="wide" className="relative py-12 md:py-16">
        <Link to="/usp/painel" className="inline-flex items-center gap-1.5 text-[length:var(--text-body-sm)] text-[color:var(--color-muted-foreground)] hover:text-[color:var(--color-foreground)]">
          <ArrowLeft className="size-3.5" />
          Painel
        </Link>

        <header className="mt-8 max-w-2xl">
          <Badge variant="accentSolid" className="gap-2">
            <Target className="size-3" />
            Simulados Fuvest
          </Badge>
          <h1 className="mt-5 font-display text-[length:var(--text-display-md)] font-semibold leading-tight tracking-[var(--text-display-md--letter-spacing)] text-balance">
            Escolha o formato do simulado.
          </h1>
        </header>

        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {MODES.map(({ to, icon: Icon, title, desc, status }) => {
            const isActive = status === "ativo";
            return (
              <article
                key={title}
                className="flex flex-col rounded-2xl border border-[--color-border] bg-[color:var(--color-card)] p-7 shadow-[var(--shadow-sm)]"
              >
                <div className="flex items-center justify-between">
                  <span className="chip size-11" style={{ backgroundColor: "var(--color-accent-soft)", color: "var(--color-accent-deep)" }}>
                    <Icon className="size-5" aria-hidden />
                  </span>
                  {!isActive && <Badge variant="outline">Em breve</Badge>}
                </div>
                <h2 className="mt-5 font-display text-[length:var(--text-body-lg)] font-semibold">{title}</h2>
                <p className="mt-2 flex-1 text-[length:var(--text-body-sm)] text-[color:var(--color-muted-foreground)] leading-relaxed">
                  {desc}
                </p>
                <Button asChild={isActive} variant={isActive ? "primary" : "outline"} className="mt-6 w-full" disabled={!isActive}>
                  {isActive ? (
                    <Link to={to}>
                      Começar
                      <ArrowUpRight className="size-4" />
                    </Link>
                  ) : (
                    <span>Em breve</span>
                  )}
                </Button>
              </article>
            );
          })}
        </div>
      </Container>
    </div>
  );
}
